"use client";

// src/components/ScrollToTop.tsx
import { useEffect } from 'react';
import { usePathname } from "next/navigation";

const ScrollToTop = () => {
  // Get the current location (URL path)
  const pathname = usePathname();

  // This effect runs every time the pathname changes
  useEffect(() => {
    // Scroll the window to the top left corner
    window.scrollTo(0, 0);
  }, [pathname]); // The dependency array ensures this runs only on a route change

  return null; // This component doesn't render any visible HTML
};

export default ScrollToTop;